import { userInfoFrag } from 'packages/client/src/app/utils/type/user.common-type';
import { folderInfoFrag } from '../../../../../../utils/type/folder.common-type';

export const getMailsFrag = `
    id
    folderId
    folder {
        ${folderInfoFrag}
    }
    serviceId
    mailNumber
    type
    sender
    recipient
    sendDate
    receiveDate
    state
    note
    users {
        ${userInfoFrag} 
    }
`;
